import { useFeatureIsOn } from "@growthbook/growthbook-react";

import Loading from "web/Layout/Common/Loading";

import useCheckIfDashboardIsEnabled from "web/utils/permissions/useCheckIfDashboardIsEnabled";

import { useGetCompanyDetailsQuery } from "web/features/company/companyApiSlice";

import MainHeaderDashboard from "./MainHeaderDashboard";
import MainHeaderDefault from "./MainHeaderDefault";

const MainHeaderContainer = () => {
  const { data: company, isLoading } = useGetCompanyDetailsQuery();

  const isDashboardModuleEnabled = useCheckIfDashboardIsEnabled();
  const shouldShowMessage = company?.displayMessageOneTimeLossPoints || false;
  const isDashboardMenuEnabled = useFeatureIsOn("pwa_dashboard_menu");

  if (isLoading) {
    return <Loading />;
  }

  return isDashboardMenuEnabled && isDashboardModuleEnabled ? (
    <MainHeaderDashboard shouldShowMessage={shouldShowMessage} />
  ) : (
    <MainHeaderDefault shouldShowMessage={shouldShowMessage} />
  );
};

export default MainHeaderContainer;
